<template>
  <div class="review-table-wrapper">
    <div class="review-table-anchor" ref="anchor"></div>
    <div class="review-table-container" :key="`agreements-table-${reloadKey}`">
      <table border="2" class="payments-table">
        <thead class="payments-table-head">
          <tr>
            <th class="center-align">Creator Name</th>
            <th class="center-align">Submission Date</th>
            <th class="w0 center-align">Rate Bid</th>
            <th class="w0 center-align">
              <div>Rating</div>
              <TableHeaderActions
                :listOptions="listOptions"
                fieldName="rating"
                orders
                @orderUpdate="$emit('orderUpdate', $event)"
                fieldLabel="Rating"
              />
            </th>
            <th class="w0 center-align">Review</th>
          </tr>
        </thead>
        <tbody v-if="items && items.length">
          <GigSubmissionsReviewTableRow
            v-for="(item, idx) in items"
            :key="item.id"
            :item="item"
            @openDialog="openDialog(idx)"
          />
        </tbody>
        <tbody class="no-entries" v-else-if="items && items.length == 0">
          <tr>
            <td colspan="1000">No Submissions</td>
          </tr>
        </tbody>
      </table>
    </div>
    <slot name="pagination"></slot>
    <v-dialog v-model="dialog" content-class="submission-review-dialog">
      <v-card light class="submission-review-dialog-container">
        <v-btn class="dialog-close" icon @click="cancel">
          <v-icon>$close</v-icon>
        </v-btn>
        <v-card-text
          class="submission-review-dialog__content"
          v-if="activeSubmissionIdx !== null && items[activeSubmissionIdx]"
        >
          <SubmissionReviewForm
            class="submission-review-dialog__form"
            :submission="items[activeSubmissionIdx]"
            :submissionForm="submissionForm"
            @change="reviewHasUnsavedChanges = $event"
            :key="`submission-review-form__${activeSubmissionIdx}`"
            @prev="prev($event)"
            @next="next($event)"
            @refresh="refresh()"
            :submissionIndex="activeSubmissionIdx"
            :submissionsLength="items.length"
            @orderInvalid="clearOrder"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TableHeaderActions from "@/components/tables/TableHeaderActions";
import GigSubmissionsReviewTableRow from "./GigSubmissionsReviewTableRow.vue";
import SubmissionReviewForm from "@/components/review/SubmissionReviewForm.vue";
import submissionsReviewGroup from "@/mixins/submissions/submissions-review-group.mixin";

export default {
  mixins: [submissionsReviewGroup],
  components: {
    TableHeaderActions,
    GigSubmissionsReviewTableRow,
    SubmissionReviewForm,
  },
  props: {
    submissionForm: Object,
    items: Array,
    listOptions: Object,
    reloadKey: Number,
  },
  data() {
    return {
      dialog: false,
      activeSubmissionIdx: null,
      reviewHasUnsavedChanges: false,
    };
  },
  watch: {
    "$route.query.submission": {
      handler: function (sid) {
        if (sid !== null && sid !== this.activeSubmissionIdx) {
          this.openFromQueryParam(sid);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/payments/payments-table.scss";
@import "@/styles/review/review-table.scss";
</style>
